import Vue from 'vue';
import VueRouter from 'vue-router';
import {BasicLayout} from '@/layouts';

Vue.use(VueRouter);

// function loadView(view) {
//     return () => import(`@/views${view}.vue`);
// }
let loadView = (view) => { // 路由懒加载
  return resolve => require([`@/views${view}.vue`], resolve)
}

const routes = [
    {
        path: '/',
        name: 'layout',
        component: BasicLayout,
        redirect: '/home',
        children: [
            {
                path: '/home',
                component: loadView('/Home'),
                children: [
                  {
                    path: '',
                    component: loadView('/courseMaking/contentManagement/contentManagement')
                  },
                  {
                    path: '/courseworkSetting',
                    component: loadView('/courseMaking/courseworkSetting/courseworkSetting')
                  },
                  {
                    path: '/courseDataUpload',
                    component: loadView('/courseMaking/courseDataUpload/courseDataUpload')
                  },
                  {
                      path: '/courseQuestionBank',
                      component: loadView('/courseMaking/courseQuestionBank/courseQuestionBank')
                  },
                  {
                      path: '/courseInfoSetting',
                      component: loadView('/courseMaking/courseInfoSetting/courseInfoSetting')
                  },
                  {
                    path: '/quicklogin',
                    name:'quicklogin',
                    component: loadView('/courseMaking/quicklogin/quicklogin')
                  },
                ]
            },
            {
                path: '/settingWrap',
                component: loadView('/courseMaking/courseworkSetting/component/settingWrap'),
                children: [
                  {
                    path: '',
                    component: loadView('/courseMaking/courseworkSetting/component/jobSetting')
                  },
                  {
                    path: '/settingWrap/questionSetting',
                    component: loadView('/courseMaking/courseworkSetting/component/questionSetting')
                  }
                ]
            },
            {
              path: '/settingWrapTest',
              component: loadView('/courseMaking/courseworkSetting/component/settingWrapTest'),
            }
        ]
    }, {
      path: '/login',
      name:'login',
      component:loadView('/user/Login')
    },
    {
        path: '/timeout',
        name:'timeout',
        component:loadView('/error/timeout')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: 'maker',
    routes
})

export default router
